export default "__VITE_ASSET__7U3Jf0FN__$_?url__"